export const normalizeToolName = (toolName: string) =>
  toolName
    .replace('tool-', '')
    .replace('-', ' ')
    .replace('_', ' ')
    .replace(/\b\w/g, char => char.toUpperCase());
